import { useEffect, useState } from "react";

export function useRelativeTimeTick(intervalMs = 30000) {
  const [, forceTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => forceTick((n) => n + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
}